import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function BasicDigitalSkillsPage() {
    const [skillsGovernmentArray, setSkillsGovernmentArray] = useState<Service[]>([]);
    const [skillsIndependentsArray, setSkillsIndependentsArray] = useState<Service[]>([]);
    const [skillsShortcutsArray, setSkillsShortcutsArray] = useState<Service[]>([]);

    const getSkillsGovernment = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΔεξιοΚυβερνητικοί Οργανισμοί");

    const getSkillsIndependents = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΔεξιοΑνεξάρτητοι Οργανισμοί");

    const getSkillsShortcuts = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΔεξιοΣυντομεύσεις");

    useEffect(() => {
        setSkillsGovernmentArray(getSkillsGovernment());
    }, []);

    useEffect(() => {
        setSkillsIndependentsArray(getSkillsIndependents());
    }, []);

    useEffect(() => {
        setSkillsShortcutsArray(getSkillsShortcuts());
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const tabColor = useColorModeValue("primary", "light");

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={tabColor}>
                <TabList flex="1">
                    <Tab fontWeight="bold">Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ανεξάρτητοι Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Συντομεύσεις</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {skillsGovernmentArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {skillsIndependentsArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {skillsShortcutsArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}